import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function TestSubmitted() {
    const location = useLocation();
    const navigate = useNavigate();
    const { submission, testTitle } = location.state || {};

    if (!submission) {
        return (
            <div style={styles.container}>
                <div style={styles.card}>
                    <h2>Keine Daten vorhanden</h2>
                    <button onClick={() => navigate('/student')} style={styles.button}>
                        Zurück zum Start
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.successIcon}>✓</div>
                <h1 style={styles.title}>Test erfolgreich abgegeben!</h1>
                <div style={styles.info}>
                    <h2>{testTitle}</h2>
                    <p>Deine Abgabe wurde erfolgreich gespeichert.</p>
                </div>

                {submission.score !== null && (
                    <div style={styles.scoreSection}>
                        <h3>Dein Ergebnis:</h3>
                        <div style={styles.score}>
                            {submission.score} / {submission.max_score} Punkte
                        </div>
                        <div style={styles.percentage}>
                            {Math.round((submission.score / submission.max_score) * 100)}%
                        </div>
                    </div>
                )}

                {submission.score === null && (
                    <div style={styles.manualGrading}>
                        <p>📋 Dein Test wird von der Lehrkraft bewertet.</p>
                        <p>Das Ergebnis wird dir später mitgeteilt.</p>
                    </div>
                )}

                <button 
                    onClick={() => navigate('/student')}
                    style={styles.button}
                >
                    Weiteren Test machen
                </button>
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    card: {
        backgroundColor: 'white',
        padding: '3rem',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '500px',
        textAlign: 'center',
    },
    successIcon: {
        fontSize: '4rem',
        color: '#28a745',
        marginBottom: '1rem',
    },
    title: {
        color: '#28a745',
        marginBottom: '1.5rem',
    },
    info: {
        marginBottom: '2rem',
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
    },
    scoreSection: {
        padding: '1.5rem',
        backgroundColor: '#d4edda',
        borderRadius: '8px',
        marginBottom: '2rem',
    },
    score: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#155724',
        margin: '1rem 0',
    },
    percentage: {
        fontSize: '1.5rem',
        color: '#155724',
    },
    manualGrading: {
        padding: '1.5rem',
        backgroundColor: '#fff3cd',
        borderRadius: '8px',
        marginBottom: '2rem',
        color: '#856404',
    },
    button: {
        padding: '1rem 2rem',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
};

export default TestSubmitted;
